/* eslint-disable jsx-a11y/alt-text */
import { Layout, Input } from "antd";
import { Image } from "antd";
import { Content } from "antd/es/layout/layout";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import IMAGE_LOADING from "@assets/images/IMAGE_LOADING.gif";
import IMAGE_OFFLINE from "@assets/images/IMAGE_OFFLINE.jpg";
import NO_IMAGE_AVAILABLE from "@assets/images/NO_IMAGE_AVAILABLE.jpg";
import Header from "@components/Header";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { useSocketContext } from "@contexts/socket/socketContext";
import {
  COLOR_GREEN,
  COLOR_GREY_1,
  COLOR_RED,
  COLOR_WHITE,
} from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { FILTER_SIZE, MENU_SIZE } from "@static/SIZE";
import { convertFormatDate } from "@utils/convertFormatDate";
import { getAuthUserProfile } from "@utils/getAuthUserProfile";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { fetchAPI } from "@utils/https/fetchAPI";

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${COLOR_WHITE};
  padding: 8px;
  border-radius: 6px;
  height: 50px;
  box-sizing: border-box;
`;

const SectionScreenshotList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding-bottom: 16px;
  overflow-y: scroll;
`;

const SectionScreenshotItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  box-sizing: border-box;
  /* overflow: hidden; */
  background: rgb(245, 245, 245);
  border: 1px;
  border-style: solid;
  border-color: ${COLOR_GREY_1};
`;

const SectionMediaText = styled.div`
  padding: 8px 16px;
  width: 100%;
`;

const SectionGroupMedia = styled.div`
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const SectionMediaContents = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 180px;
  background: ${COLOR_WHITE};
  box-sizing: border-box;
  .cover-image {
    object-fit: cover;
  }
`;
const { REACT_APP_API_ENDPOINT } = process.env;

export default () => {
  const allCustomers = getUserExtraCustomers();
  const socket = useSocketContext();

  const [filterText, setFilterText] = useState("");
  const [dataList, setDataList] = useState([]);

  const authUserProfile = getAuthUserProfile();
  const user_type = _.get(authUserProfile, ["user_type"]);
  const category_customer_id = _.get(authUserProfile, ["category_customer_id"]);

  const onHandleFilterChange = (e) => {
    const value = _.get(e, ["target", "value"]);
    setFilterText(value);
  };

  const filteredDataSource = _.filter(dataList, (item) => {
    const itemName = _.chain(item).get(["device", "name"]).toLower().value();
    const lowerFilterText = _.toLower(filterText);
    return _.includes(itemName, lowerFilterText);
  });

  const initData = async () => {
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/screenshot",
      isAuth: true,
      data: { user_type, category_customer_id: allCustomers },
    });

    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      console.log("results :>> ", results);
      setDataList(results);
    }
  };

  const onHandleSocketMessageUpdateScreenShotPath = ({ message }) => {
    const deviceId = _.chain(message).get(["device_id"]).toInteger().value();
    const path = _.get(message, ["path"]);
    const updateDataList = _.chain(dataList)
      .cloneDeep()
      .map((item) => {
        return deviceId === _.get(item, ["device_id"])
          ? { ...item, path }
          : item;
      })
      .value();
    setDataList(updateDataList);
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    if (!socket) {
      return undefined;
    }
    socket.on(
      "SERVICE-EMIT-TO-BACK_OFFICE-UPDATE-SCREEN-SHOT",
      onHandleSocketMessageUpdateScreenShotPath
    );

    return () => {
      socket.off("SERVICE-EMIT-TO-BACK_OFFICE-UPDATE-SCREEN-SHOT");
    };
  }, [socket, dataList]);

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents style={{ overflow: "hidden" }}>
            <SectionMainAction>
              <Input
                placeholder="Filter by name"
                value={filterText}
                onChange={(e) => onHandleFilterChange(e)}
                style={{ width: FILTER_SIZE }}
              />
            </SectionMainAction>
            <SectionScreenshotList>
              {_.map(filteredDataSource, (item, index) => {
                const path = _.get(item, ["path"]);
                const isOnline = _.get(item, ["device", "isOnline"]);
                const lastSeen = _.get(item, ["device", "lastSeen"]) || "-";

                const formattedLastSeen =
                  lastSeen === "-"
                    ? "-"
                    : dayjs(Number(lastSeen))
                        .tz("Asia/Bangkok")
                        .format("YYYY-MM-DD HH:mm:ss");

                return (
                  <SectionScreenshotItem key={index}>
                    <SectionGroupMedia>
                      <SectionMediaContents>
                        <Image
                          height={"100%"}
                          width={"100%"}
                          className=""
                          src={
                            isOnline
                              ? `${REACT_APP_API_ENDPOINT}/${path}`
                              : IMAGE_OFFLINE
                          }
                          fallback={IMAGE_LOADING}
                          alt={_.get(item, ["name"], "-")}
                          onError={({ target }) => {
                            target.onerror = null;
                            target.src = IMAGE_LOADING;
                            target.style.objectFit = "cover"; // auto cover when load image error
                          }}
                        />
                      </SectionMediaContents>
                      <SectionMediaText>
                        <Text isEllipsis lines={1} fontWeight="500">
                          {_.get(item, ["device", "name"])}
                        </Text>
                        <Text
                          isEllipsis
                          lines={1}
                          fontWeight="700"
                          color={isOnline ? COLOR_GREEN : COLOR_RED}
                        >
                          {isOnline ? "Online" : "Offline"}
                        </Text>
                        <Text isEllipsis lines={1} fontWeight="500">
                          {formattedLastSeen}
                        </Text>
                      </SectionMediaText>
                    </SectionGroupMedia>
                  </SectionScreenshotItem>
                );
              })}
            </SectionScreenshotList>
          </InnerContents>
        </Content>
      </Layout>
    </Layout>
  );
};
